/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trace_Package_ApprovedInputs */

const vi_trace_package_approved = /** @type {(inputs: Trace_Package_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã phê duyệt`)
};

/**

* @param {Trace_Package_ApprovedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trace_package_approved = /** @type {((inputs?: Trace_Package_ApprovedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trace_Package_ApprovedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trace_package_approved(inputs)
});